import type { Media } from '@/payload-types'
import { getMediaUrl } from '@/utilities/getMediaUrl'

export type BrandingMedia = Media | string | number | null | undefined

interface ResolveBrandingAssetArgs {
  fallbackAlt: string
  fallbackMimeType?: string
  fallbackSrc: string
  resource?: BrandingMedia
}

export interface ResolvedBrandingAsset {
  alt: string
  height?: number
  mimeType?: string
  src: string
  width?: number
}

export function resolveBrandingAsset({
  fallbackAlt,
  fallbackMimeType,
  fallbackSrc,
  resource,
}: ResolveBrandingAssetArgs): ResolvedBrandingAsset {
  if (!resource || typeof resource !== 'object' || !resource.url) {
    return {
      alt: fallbackAlt,
      mimeType: fallbackMimeType,
      src: fallbackSrc,
    }
  }

  return {
    alt: resource.alt || fallbackAlt,
    height: resource.height || undefined,
    mimeType: resource.mimeType || fallbackMimeType,
    src: getMediaUrl(resource.url, resource.updatedAt),
    width: resource.width || undefined,
  }
}
